import {combineReducers} from 'redux';
import {connectRouter} from 'connected-react-router'
import signUpReducer from "./signUpReducer";
import {reducer as formReducer} from 'redux-form';
import notificationReducer from "./notificationReducer";
import modalReducer from "./modalReducer";
import infoReducer from "./infoReducer";

const reducers= (history) => combineReducers({
    router: connectRouter(history),
    auth: signUpReducer,
    form:formReducer,
    notification:notificationReducer,
    modal:modalReducer,
    info:infoReducer
});
export default reducers;